'use strict';

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _ScrollTrigger = require('gsap/ScrollTrigger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initScrollDirectionIndicator() {
  // GSAP Plugins
  _gsap2.default.registerPlugin(_ScrollTrigger.ScrollTrigger);

  /*----------------------------
  Elements
  ----------------------------*/

  var body = document.querySelector('body');

  /*----------------------------
  Fixed Nav
  ----------------------------*/
  _ScrollTrigger.ScrollTrigger.create({
    markers: false,
    trigger: body,
    start: 'top -20%',
    onUpdate: function onUpdate(self) {
      if (self.direction === 1) {
        body.classList.add('scrolling-down');
        body.classList.remove('scrolling-up');
      } else {
        body.classList.add('scrolling-up');
        body.classList.remove('scrolling-down');
      }
    },
    onLeaveBack: function onLeaveBack() {
      body.classList.remove('scrolling-up');
    }
  });
}

/*-------------------------------
Init
-------------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  initScrollDirectionIndicator();
});